import ReactCodeMirror from "@uiw/react-codemirror";
import { yaml } from "@codemirror/lang-yaml";
import SwaggerLayoutPlugin from "components/SwaggerUiLayout";
import { useEffect, useRef, useState } from "react";
import { Container, Header, Icon, Segment } from "semantic-ui-react";
import { store } from "services/state";
import { Link } from "react-router";

import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
import * as YAML from "yaml";

function PrivateApis() {
  const containerRef = useRef();
  const [showExampleSnippet, setShowExampleSnippet] = useState(true);
  const [showExampleUi, setShowExampleUi] = useState(true);

  const api = `openapi: 3.0.0
info:
  title: Internal Services API
  description: |-
    This API provides access to internal Ikano services and proprietary integrations.
    Access is restricted to authorized Ikano personnel only.
  version: 1.0.0
servers:
  - url: https://internal-api.ikano.com/v1
    description: Internal production server
paths:
  /internal/services:
    get:
      summary: Retrieve internal services
      description: Returns a list of internal services.
      operationId: getInternalServices
      tags:
        - Internal
      responses:
        "200":
          description: A list of internal services.
          content:
            application/json:
              schema:
                type: array
                items:
                  type: object
                  properties:
                    id:
                      type: string
                    name:
                      type: string
                    status:
                      type: string
        "401":
          description: Unauthorized
`;

  useEffect(() => {
    store.api = YAML.parse(api);
    SwaggerUI({
      plugins: [SwaggerLayoutPlugin],
      domNode: containerRef.current,
      spec: YAML.parse(api),
    });
  }, [api, showExampleUi]);

  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        Private APIs
      </Header>
      <Header dividing>Introduction</Header>
      The <Link to="/private-apis">Private APIs</Link> page provides
      comprehensive documentation for internal APIs accessible exclusively to
      Ikano users. These APIs are designed for proprietary services and
      integrations within the Ikano ecosystem.
      <br />
      <br />
      Private APIs follow the same Swagger/OpenAPI specification format as REST
      APIs, providing detailed information about internal endpoints,
      authentication methods, and usage guidelines that are restricted to
      authorized Ikano personnel only.
      <br />
      <Header as="h3">Access Control</Header>
      Access to Private APIs is restricted to authenticated Ikano users only.
      These APIs contain sensitive internal documentation and should not be
      shared externally.
      <Header dividing>Example</Header>
      <Segment.Group>
        <Segment>
          <Header as="h4" onClick={() => setShowExampleSnippet((s) => !s)}>
            Snippet(yaml){" "}
            <Icon name={`${showExampleSnippet ? "angle up" : "angle down"}`} />
          </Header>
          {showExampleSnippet && (
            <ReactCodeMirror
              editable={false}
              value={api}
              extensions={[yaml()]}
            />
          )}
        </Segment>
        <Segment>
          <Header as="h4" onClick={() => setShowExampleUi((s) => !s)}>
            Swagger UI{" "}
            <Icon name={`${showExampleUi ? "angle up" : "angle down"}`} />
          </Header>
          {showExampleUi && (
            <div
              className="swagger-ui-wrap"
              ref={containerRef}
              style={{ padding: "0 20px" }}
            ></div>
          )}
        </Segment>
      </Segment.Group>
    </Container>
  );
}

export default PrivateApis;
